import {
  sourceAccountId,
  cloudProvider,
  resourceGroupName,
  resourceId,
  resourceName,
  resourceType,
  sourceRegion,
  subnets,
  vpc,
  tagKeys,
  tagKeyValues,
} from '@/components/queryBuilder/properties';
import { ResourcesSelectionEditor } from '@/components/resourcesSelection/resourcesSelectionEditor';
import { StepContainer } from '@/components/wizard/StepContainer';
import type { StepProps } from '@/components/wizard/StepProps';
import {
  hasValidConditionValues,
  type FilterProperty,
} from '@/types/advanceFilter';

import type { BackupScopeResourcesEditorState } from './backupScopeResourcesWizard';

import {
  backupScopesResourcesAllExcludedDescription,
  backupScopesResourcesAllIncludedDescription,
} from '../backupScopesResources';

export const backupScopeSupportedProperties: FilterProperty[][] = [
  [resourceType],
  [
    cloudProvider,
    sourceAccountId,
    sourceRegion,
    vpc,
    subnets,
    resourceGroupName,
  ],
  [resourceName, resourceId],
  [tagKeys, tagKeyValues],
];

export const BackupScopeResourcesEditor = (
  props: StepProps<BackupScopeResourcesEditorState>
) => {
  return (
    <>
      <StepContainer
        hideStepper
        onBackClick={props.back}
        canGoNext={() =>
          props.wizardState.resourcesScopeType !== 'useConditions' ||
          hasValidConditionValues(props.wizardState.condition)
        }
        nextButtonText={'Save Changes'}
        backButtonText='Cancel'
        sx={{ padding: 0, height: '100%' }}
        onNextClick={() => props.finish()}
      >
        <ResourcesSelectionEditor
          condition={props.wizardState.condition}
          includedResources={props.wizardState.include}
          excludedResources={props.wizardState.exclude}
          setIncludedResources={(includedResources) =>
            props.setWizardState({
              ...props.wizardState,
              include: includedResources,
            })
          }
          setExcludedResources={(excludedResources) =>
            props.setWizardState({
              ...props.wizardState,
              exclude: excludedResources,
            })
          }
          resourcesScopeType={props.wizardState.resourcesScopeType}
          setResourcesScopeType={(resourcesScopeType) =>
            props.setWizardState({
              ...props.wizardState,
              resourcesScopeType,
            })
          }
          setCondition={(condition) =>
            props.setWizardState({ ...props.wizardState, condition })
          }
          supportedProperties={backupScopeSupportedProperties}
          conditionTitle='Discover resources based on these conditions:'
          allExcludedDescription={backupScopesResourcesAllExcludedDescription}
          allIncludedDescription={backupScopesResourcesAllIncludedDescription}
          manualOverridesDescription='Manually include or exclude resources from discovery process, regardless of dynamic selection.'
        />
      </StepContainer>
    </>
  );
};
